<template>
    <button @click = "$emit('click')" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs leading-4 font-medium rounded text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "BaseButtonPrimaryExtraSmall",
    }
</script>